import React, { useState, useEffect } from 'react';
import SmallFlowchart from '../SmallFlowchart';
import SmallStagechart from '../SmallStagechart';
import LargeFlowChart from '../LargeFlowChart';
import LargeStageChart from '../LargeStageChart';
import Modal from "../Modal";
import useToggle from '../UseModal';
import Damages2 from '../Damages2';
import Buildings2 from '../Buildings2';
import { Col, Row } from 'react-bootstrap';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSyncAlt } from '@fortawesome/free-solid-svg-icons'



function Current(props) {

    // hooks for local modal state (shown or hidden)
    const [open, setOpen] = useToggle(false);
    const [type, setChartType] = useState(null);
    const [refreshID, setRefreshID] = useState("refreshIcon");
    const [refreshMessage, setRefreshMessage] = useState(" ");
    const [latestReading, setLatestReading] = useState(null);

    // Need to update how the opening and closing of the modal happens on clicking on others
    function handleChartClick(type) {
        setChartType(type);
        setOpen();
    }


    function toggleModal() {
        if (open) {
            props.setBuildingMarker(null);
        }

        setOpen();
    }

    function handleRefreshClick() {
        setRefreshID("refreshInProcess");
        setRefreshMessage("");
        props.setRefreshData(moment());
    }

    const activateOnKey = (handler) => (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handler();
        }
    };

    useEffect(() => {

        function messageTimeout() {
            setTimeout(function () { setRefreshMessage('') }, 4000)
        }

        function checkData(data) {

            if (data) {
                if (latestReading === null) {
                    if (moment(data.dateTime).diff(moment(), 'minutes') < -25) {
                        setRefreshMessage("Something Went Wrong. Please Try Again.");
                        setRefreshID("refreshFailed");
                    } else {
                        setLatestReading(moment(data.dateTime));
                        setRefreshID("refreshIcon");
                    }
                } else {
                    let timeDiff = moment(data.dateTime).diff(moment(latestReading), 'minutes');

                    if (timeDiff < -25) {
                        setRefreshMessage("Something Went Wrong. Please Try Again.");
                        setRefreshID("refreshFailed");
                    } else if (timeDiff === 0) {
                        setRefreshMessage(`New Data Will Be Available At: ${moment(latestReading).add(21, 'minutes').format('LT')}`);
                        //messageTimeout();
                        setRefreshID("refreshIcon");
                    } else {
                        setRefreshMessage("Data Last Updated At: " + moment().format('lll'));
                        //messageTimeout();
                        setLatestReading(moment(data.dateTime));
                        setRefreshID("refreshIcon");
                    }
                }
            } 

        };

        if (props.observedStageData && props.observedStageData.length > 1) {
            checkData(props.observedStageData[props.observedStageData.length - 1]);
        };
    }, [props.observedStageData])

    const isIE = /*@cc_on!@*/false || !!document.documentMode;
    const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
    const isEdge = !isIE && !!window.StyleMedia;
   
    return (
       
        <div>
            {/* if a gage is selected (props passed w/ current gage name), return dashboard container.  Else return empty fragment. */}
            {props.gageName ?
                <div >
                    <h5 id="dashboardTitle">{props.gageName}
                        <span id="refreshTextTitle" role="button" tabIndex={0} aria-label="Refresh data" onClick={handleRefreshClick} onKeyDown={activateOnKey(handleRefreshClick)}><FontAwesomeIcon id={refreshID} icon={faSyncAlt} /></span>
                        <br></br>
                        <div className="gageInfoMessage" id="refreshMessageTitle" ><small>{refreshMessage} </small></div>

                    </h5>
                    <div >
                        <div className="gageInfo">
                            <span className="gageInfoItem">Gage ID: <a id="gageLink" href={`https://water.noaa.gov/gauges/RONV2#hg=official`} target="new">{props.usgsGageID}</a></span>
                            {props.gageDatum ? <span className="gageInfoItem">Datum: {props.gageDatum}ft <br /> </span> : <div></div>}
                            <span className="gageInfoItem" id="refreshText" role="button" tabIndex={0} onClick={handleRefreshClick} onKeyDown={activateOnKey(handleRefreshClick)}>Refresh Data <FontAwesomeIcon id={refreshID} icon={faSyncAlt} /></span>
                            <div className="gageInfoMessage" id="refreshMessage" ><small>{refreshMessage} </small></div>

                        </div>

                    </div>
                    <Row >
                        <Col md={3} lg={3} xl={12} className="dashboardRow">
                            <div className="dashboardItem">
                                <h6>Current Status</h6>
                                <div className="dashboardStats">
                                    {props.observedStageData && props.observedStageData.length > 1 ?
                                        <div>
                                            <div>Stage: <span className="boldValues">{props.observedStageData[props.observedStageData.length - 1].value}</span> ft.</div>
                                        </div>
                                        :
                                        <div>
                                            <div>Stage: No Stage Data Available</div>
                                        </div>
                                    }

                                    {props.gageDatum && props.observedStageData && props.observedStageData.length > 1 ?
                                        <div>
                                            <div>Elevation: <span className="boldValues">{(parseFloat(props.gageDatum) + parseFloat(props.observedStageData[props.observedStageData.length - 1].value)).toFixed(1)}</span> ft. <small>NAVD88</small></div>
                                        </div>
                                        :
                                        <div>
                                            <div>Elevation: No Elevation Data Available</div>
                                        </div>
                                    }

                                    {(props.observedFlowData && props.observedFlowData.length > 1) ?
                                        <div>
                                            <div>Flow: <span className="boldValues">{props.observedFlowData[props.observedFlowData.length - 1].value}</span> cfs</div>
                                        </div>
                                        :
                                        <div>
                                            <div>Flow: No Flow Data Available</div>
                                        </div>
                                    }
                                </div>
                                <small>Last Updated:
                                        {(props.observedStageData && props.observedStageData.length > 1) ? "   " + moment(props.observedStageData[props.observedStageData.length - 1].dateTime).format('lll')
                                        : null
                                    }
                                </small>
                            </div>
                        </Col>
                        <Col md={3} lg={3} xl={12} className="dashboardRow">
                            <div key={"stageScenarioTable"} className="dashboardItem clickableDashboardItem" >
                                <h6>Impact Assessment</h6>
                                <div role="button" tabIndex={0} aria-label="Open impact assessment details" onClick={() => handleChartClick('impact')} onKeyDown={activateOnKey(() => handleChartClick('impact'))}>
                                    <Damages2 buildings={props.buildingsCurrent} buildingsCritical={props.buildingsCurrentCritical} elevation={props.gageDatum && props.observedStageData && props.observedStageData.length > 1 ? (parseFloat(props.gageDatum) + parseFloat(props.observedStageData[props.observedStageData.length - 1].value)).toFixed(1): null}/>
                                </div>
                            </div>
                        </Col>
                        <Col md={3} lg={3} xl={12} className="dashboardRow">
                            <div key={"stage"} className="dashboardItem clickableDashboardItem" >
                                <h6>Stage Chart (ft)</h6>
                                {(props.observedStageData && props.observedStageData.length > 1) ?
                                    <div role="button" tabIndex={0} aria-label="Open stage chart details" onClick={() => handleChartClick('stage')} onKeyDown={activateOnKey(() => handleChartClick('stage'))}>
                                        <SmallStagechart levels={props.stageLevels} data={props.observedStageData} forecastData={props.forecastStageData} />
                                    </div>
                                    :
                                    <p>No Stage Data Available</p>
                                }
                            </div>
                        </Col>
                        <Col md={3} lg={3} xl={12} className="dashboardRow">
                            <div key={"flow"} className="dashboardItem clickableDashboardItem" >
                                <h6>Flow Chart (cfs) </h6>
                                {(props.observedFlowData && props.observedFlowData.length > 1) && props.forecastFlowData ?
                                    <div role="button" tabIndex={0} aria-label="Open flow chart details" onClick={() => handleChartClick('flow')} onKeyDown={activateOnKey(() => handleChartClick('flow'))}>
                                        <SmallFlowchart data={props.observedFlowData} forecastData={props.forecastFlowData} />
                                    </div>
                                    :
                                    <small>No Flow Data Available</small>
                                }
                            </div>
                        </Col>
                    </Row>
                    <Modal
                        open={open}
                        toggle={toggleModal}
                    >
                        <div>
                            {type === 'impact' ?
                                <div>
                                    <h4 className="largeChartTitle draggable cursor">Impact Assesment</h4>
                                    <Buildings2 buildings={props.buildingsCurrent} setBuildingMarker={props.setBuildingMarker} setCenterAndZoom={props.setCenterAndZoom}/>
                                </div>
                                :
                                type === 'stage' ?
                                    <div>
                                        <h4 className={isEdge || isChrome ? "largeChartTitle draggable cursor" : "largeChartTitle"}>{props.gageName}</h4>
                                        <p>Stage Conditions</p>
                                        <LargeStageChart levels={props.stageLevels} data={props.observedStageData} forecastData={props.forecastStageData}></LargeStageChart>
                                    </div>
                                    :
                                    <div>
                                        <h4 className={isEdge || isChrome ? "largeChartTitle draggable cursor" : "largeChartTitle"}>{props.gageName}</h4>
                                        <p>Flow Conditions</p>
                                        <LargeFlowChart data={props.observedFlowData} forecastData={props.forecastFlowData}></LargeFlowChart>
                                    </div>
                            }
                        </div>
                    </Modal>

                </div>
                :
                <div>
                    <h5 id="dashboardMessage">Click a gage to get started</h5>
                    <div >
                        <p className="gageInfo">
                            <span className="gageInfoItem">Please select the Walnut Ave gage (large colored circle) on the map to view its current stage and flow data...</span>
                        </p>
                    </div>
                </div>
            }
        </div>
        );
};

export default Current;


// WEBPACK FOOTER //
// ./src/components/Current2/index.js